import { defineComponent as _defineComponent } from 'vue'
interface InputProps {
  inputId: string
  label?: string
  rules?: string
  mode?: string | InteractionModeFactory
}


import { defineComponent } from 'vue'
import { ValidationProvider } from 'vee-validate'
import type { InteractionModeFactory } from 'vee-validate/dist/types/modes'

const __default__ = defineComponent({
  inheritAttrs: false,
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'FormGroup',
  props: {
    inputId: null,
    label: { default: undefined },
    rules: { default: undefined },
    mode: { default: 'passive' }
  },
  setup(__props: any) {



return { __sfc: true,ValidationProvider }
}

})